export default "__VITE_ASSET__B6SWfT8J__"